// extracted by mini-css-extract-plugin
export var externalLink = "_fy-0";
export var internalLinkLabel = "_fy-1";